// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SERVER_URL: 'https://black-365.com',
}